import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null,
    isLogin: false,
    isGetUser: false
  },
  mutations: {
    SET_USER_INFO(state, payload: any) {
      state.userInfo = payload
    },
    SET_LOGIN_STATUS(state, payload: any) {
      state.isLogin = payload
    },
    SET_IS_USER_STATUS(state, payload: any) {
      state.isGetUser = payload
    },
  },
  actions: {
    setUserInfo(context, userInfo: number) {
      context.commit('SET_USER_INFO', userInfo);
    },
    setLoginStatus(context, status: boolean) {
      context.commit('SET_LOGIN_STATUS', status);
    },
    setIsUserStatus(context, status: boolean) {
      context.commit('SET_IS_USER_STATUS', status);
    },
  },
  modules: {
  }
})
